var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.03 8.96698L13.75 3.64587C12.73 2.78569 11.26 2.78569 10.25 3.64587L3.97 8.96698C3.35 9.48708 3 10.2572 3 11.0674V18.1789C3 19.7392 4.23 20.9995 5.75 20.9995H18.25C19.77 20.9995 21 19.7292 21 18.1789V11.0674C21 10.2572 20.65 9.49709 20.03 8.96698ZM14.5 19.4992H9.5V14.2481C9.5 13.838 9.84 13.4979 10.25 13.4979H13.75C14.16 13.4979 14.5 13.838 14.5 14.2481V19.4992ZM19.5 18.1789C19.5 18.909 18.94 19.4992 18.25 19.4992H16V14.2481C16 13.0078 14.99 11.9976 13.75 11.9976H10.25C9.01 11.9976 8 13.0078 8 14.2481V19.4992H5.75C5.06 19.4992 4.5 18.909 4.5 18.1789V11.0674C4.5 10.6973 4.66 10.3473 4.94 10.1172L11.22 4.7861C11.45 4.59606 11.72 4.49604 12 4.49604C12.28 4.49604 12.55 4.59606 12.78 4.7861L19.06 10.1072C19.34 10.3473 19.5 10.6873 19.5 11.0574V18.1689V18.1789Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cde6cf81.svg";
export { ForwardRef as ReactComponent };